import { DATE_FORMAT, TIME_FORMAT_WITH_UTC } from "../config/constants";
import { dayjs } from "../lib/dayjs";

export const formatAxisDateTimeToEchartsPattern = (
  xAxisDate: string | undefined
) => {
  switch (xAxisDate) {
    case "MM/DD/YYYY":
      return "{MM}/{dd}";
    case "MM/DD/YYYY HH:mm":
      return "{MM}/{dd} {HH}:{mm}";
    case "DD/MM/YYYY HH:mm":
      return "{dd}/{MM} {HH}:{mm}";
    case "DD/MM/YY":
    case "DD/MM/YYYY":
      return "{dd}/{MM}";
    case "HH:mm:ss":
      return "{HH}:{mm}:{ss}";
    default:
      return "{HH}:{mm}";
  }
};

export const isoDatePatterns = [
  /^\d{4}-\d{2}-\d{2}$/,
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}([+-](?:0[0-9]|1[0-2]):[0-5]\d|Z)$/,
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}([+-](?:0[0-9]|1[0-2]):[0-5]\d|Z)$/,
];

export const isValidDate = (value: string): boolean => {
  if (typeof value !== "string") return false;

  const trimmedValue = value.trim();

  // Normalize microsecond ISO strings to milliseconds for Day.js
  const normalizedValue = trimmedValue.replace(
    /\.(\d{3})\d+(Z|[+-]\d{2}:\d{2})$/,
    '.$1$2'
  );

  const matchesIsoPattern = isoDatePatterns.some((pattern) =>
    pattern.test(normalizedValue)
  );

  if (matchesIsoPattern) {
    const date = dayjs(normalizedValue);
    return date.isValid() && date.year() > 1900 && date.year() < 2100;
  }

  const dateWithUTC = dayjs(normalizedValue, TIME_FORMAT_WITH_UTC, true);
  const dateOnly = dayjs(normalizedValue, DATE_FORMAT, true);

  if (dateWithUTC.isValid()) {
    return dateWithUTC.year() > 1900 && dateWithUTC.year() < 2100;
  }

  if (dateOnly.isValid()) {
    return dateOnly.year() > 1900 && dateOnly.year() < 2100;
  }

  return false;
};

